module.exports = __webpack_public_path__ + "media/images/front/icon_01_time-7213accc70cafd7d0aac1958733f60c4.png";